export default __webpack_public_path__ + "2d1a3d8758d2b9343cfe782d4166bf3a.png";